/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Address, HexString, Val, Struct } from "@alephium/web3";
import { default as allStructsJson } from "../structs.ral.json";
export const AllStructs = allStructsJson.map((json) => Struct.fromJson(json));
export interface LeaderboardEntry extends Record<string, Val> {
  userAddr: Address;
  score: bigint;
  periodicScore: bigint;
  lastUpdateTime: bigint;
}
export interface LeaderboardPeriodicTop extends Record<string, Val> {
  first: LeaderboardEntry;
  second: LeaderboardEntry;
  third: LeaderboardEntry;
  startTime: bigint;
  endTime: bigint;
  rewardPool: bigint;
  periodDuration: bigint;
}
export interface RocketRangeGameInstance extends Record<string, Val> {
  gameId: bigint;
  betOpenTime: bigint;
  betCloseTime: bigint;
  gameEndTime: bigint;
  openPrice: bigint;
  openPriceUpdatedAt: bigint;
  closePrice: bigint;
  closePriceUpdatedAt: bigint;
  result: bigint;
  totalPotSize: bigint;
  optionOnePotSize: bigint;
  optionTwoPotSize: bigint;
  optionThreePotSize: bigint;
  optionFourPotSize: bigint;
  optionFivePotSize: bigint;
  potFeesClaimed: bigint;
}
export interface RocketRangeGameSettings extends Record<string, Val> {
  gameWindowDuration: bigint;
  downBigTreshold: bigint;
  downSmallTreshold: bigint;
  upSmallTreshold: bigint;
  upBigTreshold: bigint;
  pairName: HexString;
  protocolFeeClaimer: Address;
  minNextRoundPot: bigint;
  splitNNextRoundPot: bigint;
  paused: boolean;
}
export interface RocketRangeOracleValue extends Record<string, Val> {
  value: bigint;
  timestamp: bigint;
}
export interface RocketRangeUserBet extends Record<string, Val> {
  userAddr: Address;
  prevRoundId: bigint;
  prevRoundBetOneChoice: bigint;
  prevRoundBetOneSize: bigint;
  prevRoundBetTwoChoice: bigint;
  prevRoundBetTwoSize: bigint;
  liveRoundId: bigint;
  liveRoundBetOneChoice: bigint;
  liveRoundBetOneSize: bigint;
  liveRoundBetTwoChoice: bigint;
  liveRoundBetTwoSize: bigint;
}
export interface UpgradableSettings extends Record<string, Val> {
  upgradeDelay: bigint;
  owner: Address;
  newOwner: Address;
  upgradeCommenced: bigint;
  newCode: HexString;
}
